import React from 'react';
import MarketingHeader from '../../components/MarketingHeader';
import { useSocialAnalytics, useSyncSocialAnalyticsNow } from '../../hooks/useSocial';
import { PrimaryButton } from '../../styles/marketingSharedStyles';
import { Card, CardTitle, Grid, Item, List, Metric, MetricLabel, MetricValue, Page, Row, Subtle } from './socialStyles';

const SocialAnalyticsPage: React.FC = () => {
  const analytics = useSocialAnalytics();
  const syncNow = useSyncSocialAnalyticsNow();

  return (
    <Page>
      <MarketingHeader activeTab="social" />
      <Card>
        <Row>
          <CardTitle>Social Analytics</CardTitle>
          <PrimaryButton type="button" onClick={() => syncNow.mutate({})} disabled={syncNow.isPending}>
            {syncNow.isPending ? 'Syncing...' : 'Sync Now'}
          </PrimaryButton>
        </Row>
        <Subtle>Aggregated metrics from Facebook, Instagram, and YouTube post snapshots.</Subtle>
      </Card>

      <Grid>
        <Metric>
          <MetricLabel>Impressions</MetricLabel>
          <MetricValue>{(analytics.data?.totals.impressions ?? 0).toLocaleString()}</MetricValue>
        </Metric>
        <Metric>
          <MetricLabel>Reach</MetricLabel>
          <MetricValue>{(analytics.data?.totals.reach ?? 0).toLocaleString()}</MetricValue>
        </Metric>
        <Metric>
          <MetricLabel>Likes</MetricLabel>
          <MetricValue>{(analytics.data?.totals.likes ?? 0).toLocaleString()}</MetricValue>
        </Metric>
      </Grid>
      <Grid>
        <Metric>
          <MetricLabel>Comments</MetricLabel>
          <MetricValue>{(analytics.data?.totals.comments ?? 0).toLocaleString()}</MetricValue>
        </Metric>
        <Metric>
          <MetricLabel>Shares</MetricLabel>
          <MetricValue>{(analytics.data?.totals.shares ?? 0).toLocaleString()}</MetricValue>
        </Metric>
        <Metric>
          <MetricLabel>Clicks</MetricLabel>
          <MetricValue>{(analytics.data?.totals.clicks ?? 0).toLocaleString()}</MetricValue>
        </Metric>
      </Grid>

      <Card>
        <CardTitle>Latest Analytics Snapshots</CardTitle>
        {analytics.isLoading ? (
          <Subtle>Loading analytics...</Subtle>
        ) : (
          <List>
            {(analytics.data?.snapshots ?? []).slice(0, 20).map((snapshot) => (
              <Item key={snapshot.id}>
                <Row>
                  <strong>{snapshot.platform}</strong>
                  <span>{snapshot.platform_post_id ?? 'N/A'}</span>
                  <span>Impressions: {snapshot.impressions.toLocaleString()}</span>
                  <span>Reach: {snapshot.reach.toLocaleString()}</span>
                  <span>Likes: {snapshot.likes.toLocaleString()}</span>
                  <span>{new Date(snapshot.snapshot_at).toLocaleString()}</span>
                </Row>
              </Item>
            ))}
          </List>
        )}
      </Card>
    </Page>
  );
};

export default SocialAnalyticsPage;
